import { Component, OnInit } from '@angular/core';
import { AppTableDisplayColumn } from '@ui-kit/webkit/components/crud-table/crud-table.model';
import { CalendarBooking } from '../models/atoku-calendar.model';
import { AtokuService } from '../services/atoku.service';

type StorageType = 'Cold' | 'Freezer' | 'Dry';

interface Station {
    name: string;
    category: string;
    spaceCode?: string;
    subSpaceCode?: string;
}

interface EquipmentOption {
    id: string;
    name: string;
    quantity: number;
}

interface BlockOutEquipmentSelection extends EquipmentOption {
    selectedQuantity: number;
}

interface StorageUnit {
    name: string;
    type: StorageType;
    totalAmount: number;
}

interface StorageBooking {
    id: number;
    date: Date;
    storageName: string;
    userName: string;
    amount: number;
}

interface HourBookingDisplay {
    hour: number;
    booking?: CalendarBooking;
    isBooked: boolean;
    isStart: boolean;
    isEnd: boolean;
    isSelectionStart?: boolean;
    isSelectionEnd?: boolean;
    isSelectedRange?: boolean;
}

interface BookingTableRow {
    id: string;
    date: string;
    timeRange: string;
    durationHours: number;
    stationName: string;
    stationCategory: string;
    userName: string;
    equipmentSummary: string;
    status: string;
}

interface StorageTableRow {
    id: string;
    date: string;
    storageName: string;
    storageType: StorageType;
    userName: string;
    amount: number;
    available: number;
}

class CalendarCrudTableModel {}
const STATIONS: Station[] = [
    { name: 'New shared commercial kitchen station 1', category: 'Shared' },
    { name: 'Receiving prep station 2', category: 'Receiving Prep' },
    { name: 'New shared commercial kitchen station 9', category: 'Shared' },
    { name: 'New shared commercial kitchen station 8', category: 'Shared' },
    { name: 'New shared commercial kitchen station 7', category: 'Shared' },
    { name: 'New shared commercial kitchen station 6', category: 'Shared' },
    { name: 'New shared commercial kitchen station 5', category: 'Shared' },
    { name: 'New shared commercial kitchen station 4', category: 'Shared' },
    { name: 'New shared commercial kitchen station 3', category: 'Shared' },
    { name: 'New shared commercial kitchen station 2', category: 'Shared' },
    { name: 'Hot Section-6', category: 'Hot Kitchen' },
    { name: 'Recieving prep station', category: 'Receiving Prep' },
    { name: 'Cold/ pastry kitchen station 6', category: 'Cold/ Pastry Kitchen' },
    { name: 'Cold/ pastry Kitchen station 1', category: 'Cold/ Pastry Kitchen' },
    { name: 'Cold/ pastry kitchen station 2', category: 'Cold/ Pastry Kitchen' },
    { name: 'Cold/ pastry kitchen station 3', category: 'Cold/ Pastry Kitchen' },
    { name: 'Cold/ pastry kitchen station 4', category: 'Cold/ Pastry Kitchen' },
    { name: 'Cold/ Pastry kitchen station 5', category: 'Cold/ Pastry Kitchen' },
    { name: 'Hot kitchen - workstation 1', category: 'Hot Kitchen' },
    { name: 'Hot Kitchen - workstation 2', category: 'Hot Kitchen' },
    { name: 'Hot kitchen - workstation 3', category: 'Hot Kitchen' },
    { name: 'Hot kitchen- workstation 4', category: 'Hot Kitchen' },
    { name: 'Hot kitchen - workstation 5', category: 'Hot Kitchen' },
];

const EQUIPMENT_NAMES: string[] = [
    'Blender jug 1.5l',
    'Juicer',
    'Vacuum sealer',
    'iVARIO (TILTING PAN)',
    'iCOMBI OVEN',
    'BLAST FREEZER',
    'Induction 1 plate',
    'Convection Oven',
    'Kenwood Mixer',
    'Pastry sheeter',
    'Display fridge movable',
    'Dehydrator',
    'Kitchenaid - small',
    'Kitchenaid - Large',
    'Sous vide machine',
    'T/T Deep fryer - 5 l',
    'Deck Oven',
    'Blender jug 2 l',
    'Gravity slicer',
    'Stick blender mini',
    'Robot coupe stick blender',
    'Robot coupe 1',
    'Planetary mixer',
    'Charcoal oven - Diablo',
    'Tiltling pan',
    'Combi oven - Hot',
    'Gas Hob - 2 burner',
    'FS Deep fryer 10 L',
    'Induction 2 plate',
    'Combi oven - Baking',
    'Proofer',
];

const BOOKING_CATEGORIES = ['Training', 'Meeting', 'Workshop', 'Collab', 'Prep', 'Cleanup'];
const FIRST_NAMES = ['Zanele', 'Liam', 'Amina', 'Kai', 'Noah', 'Ayanda', 'Tariq', 'Ivy', 'Leo', 'Chloe'];
const LAST_NAMES = ['Dube', 'Ngwenya', 'Smith', 'Patel', 'Johnson', 'Peters', 'Mokoena', 'Brown', 'Lee', 'Khan'];
const STORAGE_TYPES: Array<'All' | StorageType> = ['All', 'Cold', 'Freezer', 'Dry'];

const STORAGE_UNITS: StorageUnit[] = [
    { name: 'Dry storage movable trolley', type: 'Dry', totalAmount: 24 },
    { name: 'Walk in Dry Store Cage', type: 'Dry', totalAmount: 300 },
    { name: 'Freezer Shelf', type: 'Freezer', totalAmount: 100 },
    { name: 'Fridge Shelf', type: 'Cold', totalAmount: 100 },
    { name: 'K/I Walk in fridge shelf', type: 'Cold', totalAmount: 82 },
    { name: 'K/I Walk- in fridge rack - 4 shelves', type: 'Cold', totalAmount: 4 },
    { name: 'K/I Walk in fridge shared cage - 8 Shelves', type: 'Cold', totalAmount: 2 },
    { name: 'M/L -Walk in Dry store cage shelf', type: 'Dry', totalAmount: 33 },
    { name: 'M/L Walk -in Dry store cage with shelves', type: 'Dry', totalAmount: 4 },
    { name: 'M/L - share dry store cage- 8 shelves', type: 'Dry', totalAmount: 9 },
    { name: 'M/L - Freezer shelf', type: 'Freezer', totalAmount: 20 },
    { name: 'M/L Freezer Upright rack -4 shelves', type: 'Freezer', totalAmount: 50 },
    { name: 'M/L Walk fridge cage with shelves', type: 'Cold', totalAmount: 15 }
];

@Component({
    selector: 'app-atoku-calendar',
    templateUrl: './atoku-calendar.component.html',
    styleUrls: ['./atoku-calendar.component.scss']
})
export class AtokuCalendarComponent implements OnInit {
    viewFilter: 'bookings' | 'storage' = 'bookings';
    displayMode: 'calendar' | 'table' = 'calendar';
    currentDate: Date = this.stripTime(new Date());
    weekDays: Date[] = [];
    hours: number[] = Array.from({ length: 24 }, (_, i) => i);
    readonly bookingTableDisplayColumns: AppTableDisplayColumn[] = [
        new AppTableDisplayColumn({
            colName: 'date',
            displayLabel: 'Date',
            visible: true,
            displayFunction: (value: string) => this.formatTableDateValue(value)
        }),
        new AppTableDisplayColumn({ colName: 'timeRange', displayLabel: 'Time', visible: true }),
        new AppTableDisplayColumn({
            colName: 'durationHours',
            displayLabel: 'Duration',
            visible: true,
            displayFunction: (value: number) => this.formatDuration(Number(value ?? 0))
        }),
        new AppTableDisplayColumn({ colName: 'stationName', displayLabel: 'Station', visible: true }),
        new AppTableDisplayColumn({ colName: 'stationCategory', displayLabel: 'Station Category', visible: true }),
        new AppTableDisplayColumn({ colName: 'userName', displayLabel: 'User', visible: true }),
        new AppTableDisplayColumn({ colName: 'equipmentSummary', displayLabel: 'Equipment', visible: true }),
        new AppTableDisplayColumn({ colName: 'status', displayLabel: 'Status', visible: true })
    ];
    readonly storageTableDisplayColumns: AppTableDisplayColumn[] = [
        new AppTableDisplayColumn({
            colName: 'date',
            displayLabel: 'Date',
            visible: true,
            displayFunction: (value: string) => this.formatTableDateValue(value)
        }),
        new AppTableDisplayColumn({ colName: 'storageName', displayLabel: 'Storage', visible: true }),
        new AppTableDisplayColumn({ colName: 'storageType', displayLabel: 'Type', visible: true }),
        new AppTableDisplayColumn({ colName: 'userName', displayLabel: 'User', visible: true }),
        new AppTableDisplayColumn({ colName: 'amount', displayLabel: 'Amount', visible: true }),
        new AppTableDisplayColumn({ colName: 'available', displayLabel: 'Available', visible: true })
    ];

    stations: Station[] = [];
    filteredStations: Station[] = [];

    searchTerm = '';
    selectedCategory = 'All';
    categories = ['All'];
    selectedEquipment = '';
    availableEquipment: string[] = [];
    availableEquipmentOptions: EquipmentOption[] = [];

    storageUnits: StorageUnit[] = [];
    filteredStorageUnits: StorageUnit[] = [];
    selectedStorageType: 'All' | StorageType = 'All';
    storageTypes = ['All'];
    storageSearchTerm = '';
    storageUserSearchTerm = '';

    allBookings: CalendarBooking[] = [];
    bookings: CalendarBooking[] = [];
    storageBookings: StorageBooking[] = [];
    activeTableData: Array<BookingTableRow | StorageTableRow> = [];
    readonly calendarCrudTableModel = CalendarCrudTableModel;

    selectedStation?: Station;
    selectedStorage?: StorageUnit;
    selectedDate?: Date;
    blockOutStartHour?: number;
    blockOutEndHour?: number;
    showBlockOutModal = false;
    blockOutReason = '';
    blockOutTitle = '';
    blockOutStationCodes: string[] = [];
    blockOutEquipment: BlockOutEquipmentSelection[] = [];
    blockOutError = '';
    isSavingBlockOut = false;

    constructor(private atokuService: AtokuService) {}

    ngOnInit(): void {
        this.updateWeekDays();
        this.loadLiveData();
    }

    previous(): void {
        const prevDate = new Date(this.currentDate);
        prevDate.setDate(prevDate.getDate() - 7);
        this.currentDate = this.stripTime(prevDate);
        this.updateWeekDays();
        this.loadBookingsForCurrentView();
        this.updateSelectedDate();
    }

    next(): void {
        const nextDate = new Date(this.currentDate);
        nextDate.setDate(nextDate.getDate() + 7);
        this.currentDate = this.stripTime(nextDate);
        this.updateWeekDays();
        this.loadBookingsForCurrentView();
        this.updateSelectedDate();
    }

    previousMonth(): void {
        const prevDate = new Date(this.currentDate);
        prevDate.setMonth(prevDate.getMonth() - 1);
        this.currentDate = this.stripTime(prevDate);
        this.updateWeekDays();
        this.loadBookingsForCurrentView();
        this.updateSelectedDate();
    }

    nextMonth(): void {
        const nextDate = new Date(this.currentDate);
        nextDate.setMonth(nextDate.getMonth() + 1);
        this.currentDate = this.stripTime(nextDate);
        this.updateWeekDays();
        this.loadBookingsForCurrentView();
        this.updateSelectedDate();
    }

    onDisplayModeChange(mode: 'calendar' | 'table'): void {
        if (this.displayMode === mode) {
            return;
        }

        this.displayMode = mode;
        if (mode === 'calendar') {
            this.updateWeekDays();
            this.updateSelectedDate();
        }

        this.loadBookingsForCurrentView();
    }

    onSearchChange(event: Event): void {
        const value = (event.target as HTMLInputElement).value.trim().toLowerCase();

        if (this.viewFilter === 'storage') {
            this.storageSearchTerm = value;
            this.updateStorageList();
        } else {
            this.searchTerm = value;
            this.updateStationsList();
        }

        this.ensureSelectionInView();
    }

    onCategoryChange(): void {
        this.updateStationsList();
        this.ensureSelectionInView();
    }

    onEquipmentChange(): void {
        this.updateBookings();
    }

    onStorageTypeChange(): void {
        this.updateStorageList();
        this.ensureSelectionInView();
    }

    onStorageSearchChange(event: Event): void {
        this.storageUserSearchTerm = (event.target as HTMLInputElement).value.trim().toLowerCase();
    }

    onViewFilterChange(): void {
        this.updateBookings();
        this.updateStorageList();
        this.selectDefaultCell();
        this.syncTableData();
    }

    selectCell(station: Station, date: Date): void {
        this.selectedStation = station;
        this.selectedStorage = undefined;
        this.selectedDate = new Date(date);
        this.resetHourSelection();
    }

    selectStorageCell(storage: StorageUnit, date: Date): void {
        this.selectedStorage = storage;
        this.selectedStation = undefined;
        this.selectedDate = new Date(date);
    }

    isSelectedCell(row: Station | StorageUnit, date: Date): boolean {
        if (!this.selectedDate || !this.isSameDate(this.selectedDate, date)) {
            return false;
        }
        if (this.viewFilter === 'storage') {
            return !!this.selectedStorage && this.selectedStorage.name === row.name;
        }
        return !!this.selectedStation && this.selectedStation.name === row.name;
    }

    isToday(date: Date): boolean {
        return this.isSameDate(date, new Date());
    }

    getStationDayHours(station: Station, date: Date): number {
        const total = this.bookings
            .filter(b => this.matchesStationBooking(station, b) && this.isSameDate(b.date, date))
            .reduce((sum, booking) => sum + booking.durationHours, 0);
        return Math.min(total, 24);
    }

    getStorageDayBookedAmount(storage: StorageUnit, date: Date): number {
        return this.storageBookings
            .filter(b => b.storageName === storage.name && this.isSameDate(b.date, date))
            .reduce((sum, booking) => sum + booking.amount, 0);
    }

    get bookingTableRows(): BookingTableRow[] {
        return this.bookings
            .map((booking) => this.toBookingTableRow(booking))
            .filter((row): row is BookingTableRow => row !== null)
            .sort((a, b) =>
                a.date.localeCompare(b.date)
                || a.timeRange.localeCompare(b.timeRange)
                || a.stationName.localeCompare(b.stationName)
                || a.userName.localeCompare(b.userName)
            );
    }

    get storageTableRows(): StorageTableRow[] {
        return this.storageBookings
            .map((booking) => this.toStorageTableRow(booking))
            .filter((row): row is StorageTableRow => row !== null)
            .sort((a, b) =>
                a.date.localeCompare(b.date)
                || a.storageName.localeCompare(b.storageName)
                || a.userName.localeCompare(b.userName)
            );
    }

    get bookingTableCount(): number {
        return this.bookingTableRows.length;
    }

    get activeTableCount(): number {
        return this.viewFilter === 'storage' ? this.storageTableRows.length : this.bookingTableCount;
    }

    get activeTableDisplayColumns(): AppTableDisplayColumn[] {
        return this.viewFilter === 'storage' ? this.storageTableDisplayColumns : this.bookingTableDisplayColumns;
    }

    get activeTableHeading(): string {
        return this.viewFilter === 'storage' ? 'Storage List' : 'Bookings List';
    }

    get activeTableLabel(): string {
        return this.viewFilter === 'storage' ? 'Storage' : 'Bookings';
    }

    get activeTableCountLabel(): string {
        return this.viewFilter === 'storage' ? 'rows' : 'bookings';
    }

    get calendarRangeLabel(): string {
        if (this.weekDays.length === 0) {
            return '';
        }

        const start = this.weekDays[0];
        const end = this.weekDays[this.weekDays.length - 1];
        return `${start.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' })} - ${end.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' })}`;
    }

    getRowValue(row: Station | StorageUnit, date: Date): number {
        if (this.viewFilter === 'storage') {
            return this.getStorageDayBookedAmount(row as StorageUnit, date);
        }
        return this.getStationDayHours(row as Station, date);
    }

    getRowUtilization(row: Station | StorageUnit, date: Date): number {
        if (this.viewFilter === 'storage') {
            const storage = row as StorageUnit;
            const booked = this.getStorageDayBookedAmount(storage, date);
            return storage.totalAmount ? Math.min(booked / storage.totalAmount, 1) : 0;
        }
        return this.getStationDayHours(row as Station, date) / 24;
    }

    getBookingPillClass(utilization: number): string {
        if (utilization <= 0.25) return 'pill-low';
        if (utilization <= 0.5) return 'pill-mid';
        if (utilization <= 0.75) return 'pill-high';
        return 'pill-full';
    }

    getBookingsForStationHour(station: Station, date: Date, hour: number): CalendarBooking[] {
        return this.bookings.filter(b =>
            this.matchesStationBooking(station, b) &&
            this.isSameDate(b.date, date) &&
            hour >= b.startHour &&
            hour < b.startHour + b.durationHours
        );
    }

    getSelectedHourItems(): HourBookingDisplay[] {
        const items: HourBookingDisplay[] = this.hours.map(hour => ({
            hour,
            isBooked: false,
            isStart: false,
            isEnd: false
        }));

        if (!this.selectedStation || !this.selectedDate) {
            return items;
        }

        const dayBookings = this.bookings
            .filter(b => this.matchesStationBooking(this.selectedStation!, b) && this.isSameDate(b.date, this.selectedDate!))
            .sort((a, b) => a.startHour - b.startHour);

        dayBookings.forEach(booking => {
            for (let i = 0; i < booking.durationHours; i++) {
                const hour = booking.startHour + i;
                if (hour < 0 || hour >= items.length) {
                    continue;
                }
                const item = items[hour];
                if (!item.booking) {
                    item.booking = booking;
                }
                item.isBooked = true;
                if (i === 0) {
                    item.isStart = true;
                }
                if (i === booking.durationHours - 1) {
                    item.isEnd = true;
                }
            }
        });

        if (this.blockOutStartHour !== undefined && this.blockOutEndHour !== undefined) {
            const start = Math.min(this.blockOutStartHour, this.blockOutEndHour);
            const end = Math.max(this.blockOutStartHour, this.blockOutEndHour);
            for (let hour = start; hour <= end; hour++) {
                if (items[hour]) {
                    items[hour].isSelectedRange = true;
                    items[hour].isSelectionStart = hour === start;
                    items[hour].isSelectionEnd = hour === end;
                }
            }
        } else if (this.blockOutStartHour !== undefined && items[this.blockOutStartHour]) {
            items[this.blockOutStartHour].isSelectedRange = true;
            items[this.blockOutStartHour].isSelectionStart = true;
            items[this.blockOutStartHour].isSelectionEnd = true;
        }

        return items;
    }

    onHourSlotClick(item: HourBookingDisplay): void {
        if (!this.selectedStation || !this.selectedDate || item.isBooked) {
            return;
        }

        this.blockOutError = '';
        if (this.blockOutStartHour === undefined) {
            this.blockOutStartHour = item.hour;
            this.blockOutEndHour = undefined;
            return;
        }

        const start = Math.min(this.blockOutStartHour, item.hour);
        const end = Math.max(this.blockOutStartHour, item.hour);
        if (this.hasBookingBetweenHours(start, end)) {
            this.blockOutError = 'The selected range crosses an existing booking.';
            this.blockOutStartHour = item.hour;
            this.blockOutEndHour = undefined;
            return;
        }

        this.blockOutStartHour = start;
        this.blockOutEndHour = end;
        this.openBlockOutModal();
    }

    closeBlockOutModal(): void {
        if (this.isSavingBlockOut) {
            return;
        }
        this.resetBlockOutState();
    }

    toggleBlockOutStation(station: Station, checked: boolean): void {
        const code = this.stationCode(station);
        if (!code) {
            return;
        }

        const codes = new Set(this.blockOutStationCodes);
        checked ? codes.add(code) : codes.delete(code);
        this.blockOutStationCodes = Array.from(codes);
    }

    isBlockOutStationSelected(station: Station): boolean {
        const code = this.stationCode(station);
        return !!code && this.blockOutStationCodes.includes(code);
    }

    getBlockOutStationOptions(): Station[] {
        if (!this.selectedStation?.spaceCode) {
            return this.filteredStations;
        }

        return this.filteredStations.filter(station => station.spaceCode === this.selectedStation?.spaceCode);
    }

    updateBlockOutEquipmentQuantity(item: BlockOutEquipmentSelection, quantity: number): void {
        const safeQuantity = Math.max(0, Math.min(Number(item.quantity ?? 0), Number(quantity) || 0));
        item.selectedQuantity = safeQuantity;
    }

    saveBlockOut(): void {
        if (!this.selectedStation || !this.selectedDate || this.blockOutStartHour === undefined || this.blockOutEndHour === undefined) {
            return;
        }

        const selectedCodes = this.blockOutStationCodes.filter(Boolean);
        if (selectedCodes.length === 0) {
            this.blockOutError = 'Select at least one station.';
            return;
        }

        const startHour = Math.min(this.blockOutStartHour, this.blockOutEndHour);
        const endHour = Math.max(this.blockOutStartHour, this.blockOutEndHour);
        if (this.hasBookingBetweenHours(startHour, endHour, selectedCodes)) {
            this.blockOutError = 'One of the selected stations already has a booking in that time.';
            return;
        }

        const reason = this.blockOutReason.trim();
        if (!reason) {
            this.blockOutError = 'Add a reason for the block out.';
            return;
        }

        const startDate = new Date(this.selectedDate);
        startDate.setHours(startHour, 0, 0, 0);
        const endDate = new Date(this.selectedDate);
        endDate.setHours(endHour + 1, 0, 0, 0);

        this.isSavingBlockOut = true;
        this.blockOutError = '';
        this.atokuService.createBlockOut({
            title: this.blockOutTitle.trim() || reason,
            reason,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            spaceCode: this.selectedStation.spaceCode ?? '',
            subSpaceCodes: selectedCodes,
            equipment: this.blockOutEquipment
                .filter(item => item.selectedQuantity > 0)
                .map(item => ({
                    equipmentId: item.id,
                    name: item.name,
                    quantity: item.selectedQuantity
                })),
            blocked: true
        }).subscribe({
            next: () => {
                this.isSavingBlockOut = false;
                this.resetBlockOutState();
                this.loadBookingsForCurrentView();
            },
            error: (error) => {
                this.isSavingBlockOut = false;
                this.blockOutError = String(error?.error ?? error?.message ?? 'Could not create block out.');
            }
        });
    }

    getBookingDurationLabel(booking: CalendarBooking): string {
        const hours = booking.durationHours;
        return `${booking.userName} (${hours}hr${hours === 1 ? '' : 's'})`;
    }

    getBookingTimeRange(booking: CalendarBooking): string {
        const start = this.formatHour(booking.startHour);
        const end = this.formatHour(Math.min(24, booking.startHour + booking.durationHours));
        return `${start}-${end}`;
    }

    getBookingEquipmentLines(booking: CalendarBooking): string[] {
        if (booking.equipmentItems?.length) {
            return booking.equipmentItems.map(item => `${Number(item.quantity ?? 1)}x ${String(item.name ?? '')}`.trim());
        }
        if (booking.equipment) {
            const amount = booking.equipmentAmount || 1;
            return [`${amount}x ${booking.equipment}`];
        }
        return [];
    }

    private applyFilters(): void {
        this.updateStationsList();
        this.updateStorageList();
        this.updateBookings();
        this.syncTableData();
    }

    private updateStationsList(): void {
        let list = [...this.stations];
        if (this.selectedCategory !== 'All') {
            list = list.filter(station => station.category === this.selectedCategory);
        }
        if (this.searchTerm) {
            list = list.filter(station => station.name.toLowerCase().includes(this.searchTerm));
        }
        this.filteredStations = list;
        this.syncTableData();
    }

    private updateStorageList(): void {
        let list = [...this.storageUnits];
        if (this.selectedStorageType !== 'All') {
            list = list.filter(storage => storage.type === this.selectedStorageType);
        }
        if (this.storageSearchTerm) {
            list = list.filter(storage => storage.name.toLowerCase().includes(this.storageSearchTerm));
        }
        this.filteredStorageUnits = list;
        this.syncTableData();
    }

    private updateBookings(): void {
        if (this.viewFilter === 'storage') {
            this.bookings = [];
            this.syncTableData();
            return;
        }

        if (this.selectedEquipment) {
            this.bookings = this.allBookings.filter(b =>
                b.equipment === this.selectedEquipment ||
                (b.equipmentList ?? []).includes(this.selectedEquipment)
            );
        } else {
            this.bookings = [...this.allBookings];
        }

        this.syncTableData();
    }

    private updateWeekDays(): void {
        this.weekDays = [];
        for (let i = 0; i < 7; i++) {
            const d = new Date(this.currentDate);
            d.setDate(d.getDate() + i);
            this.weekDays.push(d);
        }
    }

    private updateSelectedDate(): void {
        if (!this.selectedDate || !this.weekDays.some(day => this.isSameDate(day, this.selectedDate!))) {
            this.selectedDate = this.weekDays[0];
        }
    }

    private ensureSelectionInView(): void {
        if (this.viewFilter === 'storage') {
            if (!this.selectedStorage || !this.filteredStorageUnits.some(storage => storage.name === this.selectedStorage?.name)) {
                this.selectedStorage = this.filteredStorageUnits[0];
            }
            return;
        }
        if (!this.selectedStation || !this.filteredStations.some(station => station.name === this.selectedStation?.name)) {
            this.selectedStation = this.filteredStations[0];
        }
    }

    private selectDefaultCell(): void {
        if (this.viewFilter === 'storage') {
            this.selectedStorage = this.filteredStorageUnits[0];
            this.selectedStation = undefined;
        } else {
            this.selectedStation = this.filteredStations[0];
            this.selectedStorage = undefined;
        }
        this.selectedDate = this.weekDays[0];
    }

    // private generateMockData(): void {}
    // private generateStorageMockData(): void {}

    getSelectedStorageBookings(): StorageBooking[] {
        if (!this.selectedStorage || !this.selectedDate) {
            return [];
        }
        let list = this.storageBookings.filter(b =>
            b.storageName === this.selectedStorage!.name && this.isSameDate(b.date, this.selectedDate!)
        );
        if (this.storageUserSearchTerm) {
            list = list.filter(b => b.userName.toLowerCase().includes(this.storageUserSearchTerm));
        }
        return list;
    }

    getSelectedStorageAvailable(): number {
        if (!this.selectedStorage || !this.selectedDate) {
            return 0;
        }
        const booked = this.storageBookings
            .filter(b => b.storageName === this.selectedStorage!.name && this.isSameDate(b.date, this.selectedDate!))
            .reduce((sum, booking) => sum + booking.amount, 0);
        return Math.max(this.selectedStorage.totalAmount - booked, 0);
    }

    private loadLiveData(): void {
        this.atokuService.getStations().subscribe(stations => {
            this.stations = stations.map(station => {
                const raw = station as unknown as Record<string, unknown>;
                return {
                    name: String(raw['name'] ?? ''),
                    category: String(raw['category'] ?? ''),
                    spaceCode: String(raw['spaceCode'] ?? raw['space_code'] ?? '').trim() || undefined,
                    subSpaceCode: String(raw['subSpaceCode'] ?? raw['subspaceCode'] ?? raw['sub_space_code'] ?? '').trim() || undefined
                };
            });
            this.applyFilters();
            this.selectDefaultCell();
        });

        this.atokuService.getCategories().subscribe(categories => {
            this.categories = [
                'All',
                ...categories
                    .filter(category => String(category.code ?? '').toUpperCase() !== 'STOR')
                    .map(category => category.displayName)
                    .filter(Boolean)
            ];
        });

        this.atokuService.getEquipment('equipment').subscribe(equipment => {
            this.availableEquipmentOptions = equipment.map(item => {
                const raw = item as unknown as Record<string, unknown>;
                return {
                    id: String(raw['id'] ?? raw['equipmentId'] ?? raw['code'] ?? raw['equipmentName'] ?? raw['name'] ?? ''),
                    name: String(raw['equipmentName'] ?? raw['name'] ?? ''),
                    quantity: Number(raw['totalAmount'] ?? raw['quantity'] ?? 0)
                };
            });
            this.availableEquipment = this.availableEquipmentOptions.map(item => item.name);
        });

        this.atokuService.getEquipment('storage').subscribe(storageItems => {
            this.storageUnits = storageItems.map(item => {
                const raw = item as unknown as Record<string, unknown>;
                return {
                    name: String(raw['equipmentName'] ?? raw['name'] ?? ''),
                    type: (String(raw['storageType'] ?? raw['type'] ?? 'Dry') as StorageType),
                    totalAmount: Number(raw['totalAmount'] ?? 0)
                };
            });
            const typeSet = new Set<StorageType>(this.storageUnits.map(storage => storage.type));
            this.storageTypes = ['All', ...Array.from(typeSet)];
            this.updateStorageList();
            this.selectDefaultCell();
        });

        this.loadBookingsForCurrentView();
    }

    private loadBookingsForCurrentView(): void {
        const query = this.getBookingQueryRange();
        const startDate = query.start.toISOString();
        const endDate = query.end?.toISOString();
        this.atokuService.getBookings(startDate, endDate, this.displayMode === 'calendar').subscribe(bookings => {
            this.allBookings = bookings.map(booking => ({
                ...booking,
                date: new Date(booking.date)
            }));
            this.updateBookings();
            this.selectDefaultCell();
        });
    }

    private getBookingQueryRange(): { start: Date; end?: Date } {
        if (this.displayMode === 'table') {
            const start = this.stripTime(new Date());
            return { start };
        }

        const start = this.weekDays[0] ? new Date(this.weekDays[0]) : new Date(this.currentDate);
        start.setHours(0, 0, 0, 0);

        const end = this.weekDays[6] ? new Date(this.weekDays[6]) : new Date(this.currentDate);
        end.setHours(23, 59, 59, 999);

        return { start, end };
    }

    private stripTime(date: Date): Date {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    formatHour(hour: number): string {
        const safeHour = Math.max(0, Math.min(24, hour));
        return `${safeHour.toString().padStart(2, '0')}:00`;
    }

    private formatDuration(hours: number): string {
        return `${hours} hr${hours === 1 ? '' : 's'}`;
    }

    private isSameDate(d1: Date, d2: Date): boolean {
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }

    private matchesStationBooking(station: Station, booking: CalendarBooking): boolean {
        const stationCodeNorm = this.normalizeSpaceToken(station.subSpaceCode ?? '');
        const bookingSpaceNorm = this.normalizeSpaceToken(booking.space);

        if (!stationCodeNorm || !bookingSpaceNorm) {
            return false;
        }

        return bookingSpaceNorm === stationCodeNorm;
    }

    private toBookingTableRow(booking: CalendarBooking): BookingTableRow | null {
        const station = this.filteredStations.find((item) => this.matchesStationBooking(item, booking));
        if (!station) {
            return null;
        }

        const equipmentSummary = this.getBookingEquipmentLines(booking).join(', ').trim();

        return {
            id: String(booking.id ?? ''),
            date: this.toTableDateKey(booking.date),
            timeRange: this.getBookingTimeRange(booking),
            durationHours: booking.durationHours,
            stationName: station.name,
            stationCategory: station.category,
            userName: booking.userName || '-',
            equipmentSummary: equipmentSummary || '-',
            status: booking.category || '-'
        };
    }

    private toStorageTableRow(booking: StorageBooking): StorageTableRow | null {
        const storage = this.filteredStorageUnits.find((item) => item.name === booking.storageName);
        if (!storage) {
            return null;
        }

        return {
            id: String(booking.id ?? ''),
            date: this.toTableDateKey(booking.date),
            storageName: storage.name,
            storageType: storage.type,
            userName: booking.userName || '-',
            amount: booking.amount,
            available: Math.max(storage.totalAmount - this.getStorageDayBookedAmount(storage, booking.date), 0)
        };
    }

    private syncTableData(): void {
        this.activeTableData = this.viewFilter === 'storage' ? this.storageTableRows : this.bookingTableRows;
    }

    private toTableDateKey(date: Date): string {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private formatTableDateValue(value: string): string {
        const [year, month, day] = String(value ?? '').split('-').map(Number);
        if (!year || !month || !day) {
            return value || '-';
        }

        return new Date(year, month - 1, day)
            .toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
    }

    private normalizeSpaceToken(value: string): string {
        return String(value ?? '')
            .toLowerCase()
            .replace(/[^a-z0-9]/g, '');
    }

    private openBlockOutModal(): void {
        if (!this.selectedStation || this.blockOutStartHour === undefined || this.blockOutEndHour === undefined) {
            return;
        }

        const stationCode = this.stationCode(this.selectedStation);
        this.blockOutStationCodes = stationCode ? [stationCode] : [];
        this.blockOutReason = '';
        this.blockOutTitle = 'Blocked time';
        this.blockOutEquipment = this.availableEquipmentOptions.map(item => ({
            ...item,
            selectedQuantity: 0
        }));
        this.showBlockOutModal = true;
    }

    private resetHourSelection(): void {
        this.blockOutStartHour = undefined;
        this.blockOutEndHour = undefined;
        this.blockOutError = '';
    }

    private resetBlockOutState(): void {
        this.showBlockOutModal = false;
        this.blockOutReason = '';
        this.blockOutTitle = '';
        this.blockOutStationCodes = [];
        this.blockOutEquipment = [];
        this.resetHourSelection();
    }

    private hasBookingBetweenHours(startHour: number, endHour: number, stationCodes?: string[]): boolean {
        if (!this.selectedDate) {
            return false;
        }

        const codes = stationCodes?.length
            ? stationCodes.map(code => this.normalizeSpaceToken(code))
            : this.selectedStation
                ? [this.normalizeSpaceToken(this.stationCode(this.selectedStation))]
                : [];

        return this.bookings.some(booking => {
            if (!this.isSameDate(booking.date, this.selectedDate!)) {
                return false;
            }

            const bookingCode = this.normalizeSpaceToken(booking.space);
            if (!codes.includes(bookingCode)) {
                return false;
            }

            const bookingStart = booking.startHour;
            const bookingEnd = booking.startHour + booking.durationHours - 1;
            return bookingStart <= endHour && bookingEnd >= startHour;
        });
    }

    private stationCode(station: Station): string {
        return String(station.subSpaceCode ?? station.name ?? '').trim();
    }
}
